// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyListingAliasRetrieverWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId,
  RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface GetListingAliasForListingIdParams {
  listingId: string;
  originalUrl?: string;
}

export type RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_Options =
  UseQueryOptions<string, unknown, string, readonly [string, GetListingAliasForListingIdParams]>;

const RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_GetKey = (
  getParams: GetListingAliasForListingIdParams,
) => [RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_Path, getParams] as const;

export const RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_queryOptions = (
  getParams: GetListingAliasForListingIdParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_GetKey(getParams),
    queryFn: () =>
      RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Retrieve a listing alias from listing id
 */
export const useRentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId = (
  getParams: GetListingAliasForListingIdParams,
  {
    httpClient,
    ...options
  }: Omit<
    RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_Options,
    'queryFn' | 'queryKey'
  > & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_queryOptions(getParams, {
      httpClient,
    }),
    ...options,
  });
};
useRentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId.getKey =
  RentalManagerUserPropertyListingAliasRetrieverWebApiHandler_getListingAliasForListingId_GetKey;
